/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Task_Sales_LabelInputs */

const en_home_task_sales_label = /** @type {(inputs: Home_Task_Sales_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales follow-ups`)
};

const lv_home_task_sales_label = /** @type {(inputs: Home_Task_Sales_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pārdošanas atgādinājumi`)
};

/**
* | output |
* | --- |
* | "Sales follow-ups" |
*
* @param {Home_Task_Sales_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_task_sales_label = /** @type {((inputs?: Home_Task_Sales_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Task_Sales_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_task_sales_label(inputs)
	return en_home_task_sales_label(inputs)
});